<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="850"
      scrollable
      persistent
    >
      <PagesForm
        :items="pagesAutocomplete"
        :page="editedPage"
        :errors="pagesValidationErrors"
        :disabled="savingPage"
        :loading-pages="loadingPages"
        :parent-type="parentType"
        @clear:errors="clearPagesValidationErrors"
        @cancel="$router.push({ name: 'pages' })"
        @save="onSave"
        @preview="onPreview"
        @upload:image="onImageUpload"
        @delete:image="onImageDelete"
        @upload:logos="onImageUpload"
        @delete:logo="onImageDelete"
        @upload:pdf-report="onUploadPagePdfReport"
        @delete:pdf-report="deletePagePdfReport"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus.js';
import { mapErrorsToInputs } from '@/util/forms.js';
import store from '../../store';
import PagesForm from '../../components/PagesForm';

export default {
  name: 'EditPages',

  components: { PagesForm },

  computed: {
    ...mapState('pages', [
      'pages',
      'editedPage',
      'pagesValidationErrors',
      'savingPage',
      'loadingPages',
    ]),

    ...mapGetters('pages', ['pagesAutocomplete']),

    parentType() {
      let type;
      for (let i = 0; i < this.pages?.length; i++) {
        if (this.pages[i].id === this.editedPage.parent_id) {
          type = this.pages[i].type;
        }
      }
      return type;
    },
  },

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('pages/editPage', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'pages' });
      });
  },

  methods: {
    ...mapActions('pages', [
      'updatePage',
      'clearPagesValidationErrors',
      'uploadPagesImages',
      'deletePagesImages',
      'uploadPagePdfReport',
      'deletePagePdfReport',
    ]),

    onImageUpload(images, type, modelType, modelId) {
      this.uploadPagesImages({
        images,
        type,
        modelType,
        modelId,
      }).catch((err) => {
        const errors = mapErrorsToInputs(err);
        let snackbarError = '';
        Object.values(errors).forEach((errorArray) => {
          for (let i = 0; i < errorArray.length; i++) {
            if (snackbarError.length) {
              snackbarError += `; \n${errorArray[i]}`;
            } else {
              snackbarError += errorArray[i];
            }
          }
        });
        eventBus.$emit(OPEN_SNACKBAR, snackbarError);
        throw err;
      });
    },

    onImageDelete(image) {
      this.deletePagesImages(image);
    },

    onUploadPagePdfReport(images, type, modelType, modelId) {
      this.uploadPagePdfReport({
        images,
        type,
        modelType,
        modelId,
      }).catch((err) => {
        const errors = mapErrorsToInputs(err);
        let snackbarError = '';
        Object.values(errors).forEach((errorArray) => {
          for (let i = 0; i < errorArray.length; i++) {
            if (snackbarError.length) {
              snackbarError += `; \n${errorArray[i]}`;
            } else {
              snackbarError += errorArray[i];
            }
          }
        });
        eventBus.$emit(OPEN_SNACKBAR, snackbarError);
        throw err;
      });
    },

    onSave(page) {
      this.updatePage(page).then(() => {
        this.$router.push({ name: 'pages' });
      });
    },

    onPreview(page) {
      this.updatePage(page).then(() => {
        if (page.type === 'projects') {
          window.open(this.$previewBackendUrl(`projektai/${page.parent_id}/${page.id}?`));
        } else if (page.type === 'trainings') {
          window.open(this.$previewBackendUrl('mokymai/?'));
        } else if (page.type === 'preterm_birth') {
          window.open(
            this.$previewBackendUrl(
              `sritys/${page.parent_id}/${page.id}?pavadinimas=man-gresia-prieslaikinis-gimdymas&`,
            ),
          );
        } else if (page.type === 'premature_baby') {
          window.open(
            this.$previewBackendUrl(
              `sritys/${page.parent_id}/${page.id}?pavadinimas=susilaukiau-neisnesioto-naujagimio&`,
            ),
          );
        } else if (page.type === 'already_at_home') {
          window.open(
            this.$previewBackendUrl(
              `sritys/${page.parent_id}/${page.id}?pavadinimas=mes-jau-namuose&`,
            ),
          );
        } else if (page.type === 'lost_baby') {
          window.open(
            this.$previewBackendUrl(
              `sritys/${page.parent_id}/${page.id}?pavadinimas=netekau-naujagimio&`,
            ),
          );
        }
      });
    },
  },
};
</script>
